import * as React from "react";
import { isMobile } from "react-device-detect";
import { TeaserPanel } from "../pages/home/TeaserPanel";
import { useWindowSize } from "../util/use-window-resize";
import { ScrollIcon } from "./ScrollIcon";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import "./VideoSectionTeaser.scss";
interface IVideoSectionProps {
  video: string;
  placeholder: string;
  showPlayhead?: boolean;
  onLaunch: () => void;
  showTeaser?: boolean;
}

export const VideoSectionTeaser: React.FunctionComponent<IVideoSectionProps> = (
  props
) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [showControls, setShowControls] = React.useState(false);
  const [wasStopped, setWasStopped] = React.useState(false);
  const { height } = useWindowSize();
  useScrollPosition(({ prevPos, currPos }) => {
    if (Math.abs(currPos.y) > height / 1.1) {
      onPause();
    }
  });

  function onPlay() {
    const video = videoRef.current;
    if (video) {
      props.onLaunch();
      video.play();
      setShowControls(true);
      setWasStopped(false);
    }
  }

  function onPause() {
    const video = videoRef.current;
    if (video) {
      video.pause();
    }
  }

  function onStop() {
    setWasStopped(true);
  }

  return (
    <>
      {props.showTeaser && <TeaserPanel onLaunch={() => onPlay()} />}
      <div className="VideoSectionTeaser">
        <video
          ref={videoRef}
          className="VideoSection__video"
          src={props.video}
          onPlay={onPlay}
          onPause={onPause}
          poster={props.placeholder}
          controls={showControls}
          onEnded={onStop}
        />
        {wasStopped && <IntroScrollIcon />}
      </div>
    </>
  );
};

const IntroScrollIcon = () => {
  return !isMobile ? <ScrollIcon /> : <></>;
};
